import { Link } from "react-router-dom";
import { Phone, FileText, PhoneCall } from "lucide-react";
import { TEL } from "../../lib/site";
import { useCallbackModal } from "./CallbackDialog";

export function MobileCallBar() {
  const { open } = useCallbackModal();
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-2.5 backdrop-blur-lg md:hidden" data-testid="mobile-call-bar">
      <div className="grid grid-cols-[1.4fr_1fr_1fr] gap-2">
        <a href={TEL} className="flex items-center justify-center gap-2 rounded-full bg-ag-blue py-3.5 text-sm font-bold text-white shadow-lg shadow-ag-blue/30" data-testid="mobile-bar-call-button">
          <Phone className="h-4 w-4" /> Appeler
        </a>
        <Link to="/devis" className="flex items-center justify-center gap-1.5 rounded-full bg-ag-navy py-3.5 text-sm font-bold text-white" data-testid="mobile-bar-quote-button">
          <FileText className="h-4 w-4" /> Devis
        </Link>
        <button onClick={open} className="flex items-center justify-center gap-1.5 rounded-full bg-ag-yellow py-3.5 text-sm font-bold text-ag-ink" data-testid="mobile-bar-callback-button">
          <PhoneCall className="h-4 w-4" /> Rappel
        </button>
      </div>
    </div>
  );
}
